import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import { MatDialogRef } from "@angular/material/dialog";

@Component({
  selector: 'edsng-message-dlg',
  templateUrl: './message-dlg.component.html',
  styleUrls: ['./message-dlg.component.css']
})
export class MessageDlgComponent implements OnInit {

  @Input() icon: string = "info";
  @Input() title: string;
  @Input() message: string = "";
  @Input() messageHtml: string = null;
  @Input() okButton: string = "Ok";
  @Input() cancelButton: string = "Cancel";
  @Output() onClose: EventEmitter<string> = new EventEmitter<string>();
  constructor( public dialogRef: MatDialogRef<MessageDlgComponent>) {
  }


  ngOnInit() {
    if (this.messageHtml !== null) {
      document.getElementById('html_dlg_content').innerHTML = this.messageHtml;
    } else if ( this.message !== "")  {
      document.getElementById('html_dlg_content').innerText = this.message;
    }
  }


  closeDlg(msg: string) {
    this.dialogRef.close(msg);
    this.onClose.emit(msg);
  }

}
